/* @flow weak */
import BoxBody from 'components/BoxBody.jsx';
import Button from 'components/Button.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import DialogContent from 'components/DialogContent.jsx';
import React from 'react';
import TranscriptRequestActions from 'actions/TranscriptRequestActions';
import i18n from '@remind/i18n';

class TranscriptRequestApproveView extends React.Component {
  state = { transcriptRequest: null, error: null };

  componentDidMount() {
    TranscriptRequestActions.confirm(this.token())
      .then(transcriptRequest => {
        this.setState({ transcriptRequest });
      })
      .catch(error => {
        this.setState({ error: error.message });
      });
  }

  token = () => {
    return this.props.params.token;
  };

  renderContinueButton = () => {
    return (
      <Button
        className="TranscriptRequestApproveView-continue_button"
        to="/landing"
        eventElementName="TranscriptRequestApproveView-continue_button">
        {i18n.getText('Log in to Remind')}
      </Button>
    );
  };

  renderError = () => {
    return (
      <DialogContent
        size="xsmall"
        title={i18n.getText('Message history request')}
        subtext={i18n.getText('Message history already shared.')}
        glyph="disabled"
        glyphColor="lava">
        <BoxBody>{this.renderContinueButton()}</BoxBody>
      </DialogContent>
    );
  };

  renderIncludeAnnouncementHistory = () => {
    if (!this.state.transcriptRequest.getInclAnnouncements()) {
      return null;
    }
    return <li>Announcements for all classes</li>;
  };

  renderIncludeChats = () => {
    if (!this.state.transcriptRequest.getInclChat()) {
      return null;
    }
    return <li>Chat messages with students</li>;
  };

  render() {
    if (this.state.error) {
      return this.renderError();
    }

    const { transcriptRequest } = this.state;
    if (!transcriptRequest) {
      return <CenteredLoadingIndicator />;
    }

    const adminName = transcriptRequest.getRequestorName();
    return (
      <DialogContent
        size="xsmall"
        title={i18n.getText('Message history request')}
        subtext={i18n.getText(`Your message history has been shared with ${adminName}.`)}
        glyph="check"
        glyphColor="shamrock">
        <BoxBody>{this.renderContinueButton()}</BoxBody>
      </DialogContent>
    );
  }
}

export default TranscriptRequestApproveView;



// WEBPACK FOOTER //
// ./src/user/components/TranscriptRequestApproveView.jsx